export default __webpack_public_path__ + "static/media/Curvet6.9.ba550e4a.svg";